import { render } from "./PromotionsBanner.vue?vue&type=template&id=773ca1ee"
import script from "./PromotionsBanner.vue?vue&type=script&lang=js"
export * from "./PromotionsBanner.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\daniel.montano\\Desktop\\montalvo.ti\\dish-frontend-web-site\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__